import axios from 'axios'
import {serialize} from '../../../core/_util'
const API_URL = process.env.REACT_APP_BASE_API_URL

const GET_ALL_INVESTOR_UPDATES = `${API_URL}/investor-updates`
const DELETE_INVESTOR_UPDATES = `${API_URL}/investor-updates/delete`
const CREATE_INVESTOR_UPDATES = `${API_URL}/investor-updates`
const GET_SINGLE_INVESTOR_UPDATES = `${API_URL}/investor-updates/details`
const GET_SINGLE_INVESTOR_UPDATES_PUBLIC = `${API_URL}/investor-updates/details/public`
const EDIT_INVESTOR_UPDATES = `${API_URL}/investor-updates/edit`
const CREATE_COPY_INVESTOR_UPDATES = `${API_URL}/investor-updates/copy`

const CREATE_PITCH_DECK = `${API_URL}/pitch-decks`
const GET_All_PITCH_DECK = `${API_URL}/pitch-decks`
const GET_SINGLE_PITCH_DECK = `${API_URL}/pitch-decks/details`
const UPDATE_PITCH_DECK = `${API_URL}/pitch-decks/update`
const DELETE_PITCH_DECK = `${API_URL}/pitch-decks/delete`
const SAVE_DRAFT_EMAIL = `${API_URL}/send-email/draft`
const EDIT_DRAFT_EMAIL = `${API_URL}/send-email/draft`
const GET_ALL_TEMPLATES = `${API_URL}/template`
const GET_SINGLE_TEMPLATE = `${API_URL}/template/details`
const CREATE_DRAFT = `${API_URL}/template/draft`
const PUBLISH_TEMPLATE = `${API_URL}/template/publish`
const DELETE_TEMPLATE = `${API_URL}/template/delete`
const COPY_TEMPLATE = `${API_URL}/template/copy`
const UPDATE_TEMPLATE = `${API_URL}/template/update`
const SEND_BULK_EMAILS = `${API_URL}/bulk-emails/send`

const SEND_TEST_EMAIL = `${API_URL}/send-test-email`

const CREATE_COPY_SEND_EMAIL = `${API_URL}/send-email/copy`

const GET_SENDER_EMAIL_BY_COMPANY = `${API_URL}/send-email`

const GET_SINGLE_SEND_EMAIL = `${API_URL}/send-email/details`

const GET_INVESTORUSER_FOR_ROUND = `${API_URL}/investor-user/round`

export const getAllInvestorUpdatesAPI = (
  companyId: number,
  page?: number | null,
  size?: number | null,
  type?: string | undefined,
  search?: string | undefined,
  status?: string
) => {
  const object = {
    page: page,
    size: size,
    type: type,
    search: search,
    status: status,
  }
  return axios.get(`${GET_ALL_INVESTOR_UPDATES}/${companyId}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteInvestorUpdateAPI = (investorUpdateId: number) => {
  return axios.delete(`${DELETE_INVESTOR_UPDATES}/${investorUpdateId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createInvestorUpdateAPI = (companyId: number, data: any) => {
  return axios.post(`${CREATE_INVESTOR_UPDATES}/${companyId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getSingleInvestorUpdatesAPI = (investorUpdateId: number) => {
  return axios.get(`${GET_SINGLE_INVESTOR_UPDATES}/${investorUpdateId}`, {
    validateStatus(status) {
      return true
    },
  })
}
export const getSingleInvestorUpdatesPublicAPI = (uuid: string) => {
  return axios.get(`${GET_SINGLE_INVESTOR_UPDATES_PUBLIC}/${uuid}`, {
    validateStatus(status) {
      return true
    },
  })
}
export const editInvestorUpdatesAPI = (investorUpdateId: number, data: any) => {
  return axios.put(`${EDIT_INVESTOR_UPDATES}/${investorUpdateId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const createCopyInvestorUpdateAPI = (investorUpdateId: number) => {
  return axios.post(
    `${CREATE_COPY_INVESTOR_UPDATES}/${investorUpdateId}`,
    {},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createPitchDeck = (data: any, companyId: number) => {
  return axios.post(`${CREATE_PITCH_DECK}/${companyId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getPitchDecks = (
  companyId: number,
  page?: number | null,
  size?: number | null,
  search?: string | undefined,
  type?: string
) => {
  const object = {
    page: page,
    size: size,
    search: search,
    type: type,
  }
  return axios.get(`${GET_All_PITCH_DECK}/${companyId}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getSinglePitchDeck = (pitchDeckId: any) => {
  return axios.get(`${GET_SINGLE_PITCH_DECK}/${pitchDeckId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updatePitchDeck = (data: any, pitchDeckId: any) => {
  return axios.put(`${UPDATE_PITCH_DECK}/${pitchDeckId}/status`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const deletePitchDeck = (pitchDeckId: any) => {
  return axios.delete(`${DELETE_PITCH_DECK}/${pitchDeckId}`, {
    validateStatus(status) {
      return true
    },
  })
}

//template

export const getAllTemplate = (
  companyId: number,
  page?: number | null,
  size?: number | null,
  search?: string | undefined,
  type?: string
) => {
  const object = {
    page: page,
    size: size,
    search: search,
    type: type,
  }
  return axios.get(`${GET_ALL_TEMPLATES}/${companyId}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getSingleTemplate = (templateId: any) => {
  return axios.get(`${GET_SINGLE_TEMPLATE}/${templateId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateTemplate = (data: any, templateId: any) => {
  return axios.put(`${UPDATE_TEMPLATE}/${templateId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteTemplate = (templateId: any) => {
  return axios.delete(`${DELETE_TEMPLATE}/${templateId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const copyTemplate = (templateId: number) => {
  return axios.post(
    `${COPY_TEMPLATE}/${templateId}`,
    {},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createDraft = (data: any, companyId: number) => {
  return axios.post(`${CREATE_DRAFT}/${companyId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const publishTemplate = (data: any, companyId: number) => {
  return axios.post(`${PUBLISH_TEMPLATE}/${companyId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const saveEmailDraft = (data: any) => {
  return axios.post(`${SAVE_DRAFT_EMAIL}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const editEmailDraft = (emailId: number, data: any) => {
  return axios.put(`${EDIT_DRAFT_EMAIL}/${emailId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const sendBukEmails = (data: any, companyId: number) => {
  return axios.post(`${SEND_BULK_EMAILS}/${companyId}`, data, {
    headers: {
      'X-Origin': window.location.origin,
    },
    validateStatus(status) {
      return true
    },
  })
}
export const sendTestEmail = (data: any, companyId: number) => {
  return axios.post(`${SEND_TEST_EMAIL}/${companyId}`, data, {
    headers: {
      'X-Origin': window.location.origin,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createACopyofSendEmail = (emailId: number) => {
  return axios.post(
    `${CREATE_COPY_SEND_EMAIL}/${emailId}`,
    {},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getSenderEmailsByCompany = (
  companyId: number,
  page?: number,
  size?: number,
  search?: string,
  type?: string
) => {
  const object = {
    page: page,
    size: size,
    search: search,
    type: type,
  }
  return axios.get(`${GET_SENDER_EMAIL_BY_COMPANY}/${companyId}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getSingleEmailByEmailId = (emailId: number) => {
  return axios.get(`${GET_SINGLE_SEND_EMAIL}/${emailId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getInvestorUserforRound = (
  type: string,
  searchValue: string | undefined,
  roundId: number | undefined,
  page?: number,
  size?: number
) => {
  const queryParams = {
    ...{type},
    ...(searchValue && {name: searchValue}),
    ...(page !== undefined && {page}), // Checking against undefined since page can be 0.
    ...(size !== undefined && {size}), // Similarly for size.
  }
  return axios.get(`${GET_INVESTORUSER_FOR_ROUND}/${roundId}?${serialize(queryParams)}`, {
    validateStatus() {
      return true
    },
  })
}
